/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cta_FreeInputs */

const en_nav_cta_free = /** @type {(inputs: Nav_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try now for free`)
};

const es_nav_cta_free = /** @type {(inputs: Nav_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba gratis`)
};

/**
* | output |
* | --- |
* | "Try now for free" |
*
* @param {Nav_Cta_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_cta_free = /** @type {((inputs?: Nav_Cta_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cta_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_cta_free(inputs)
	return en_nav_cta_free(inputs)
});